export default __webpack_public_path__ + "static/media/profile.f33a0b19.svg";